/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import Search from "../../assets/images/icon-search.svg";
import Arrow from "../../assets/images/pagination_arrow.svg";
import {
  // GroupAdmin,
  ManualSalarystatus,
  RelatedPartiesStatus,
} from "../../utils/Constants";
import "bootstrap-icons/font/bootstrap-icons.css";
import {
  callRequest,
  filters,
  paginationElemnts,
  exportData,
  formateDate,
  ManualSalaryList,
  ManualSalaryObject,
} from "./hook/ScreenHelper";
import { useAppSelector } from "../../hooks/hooks";
import { useTranslation } from "react-i18next";
// import { Roles } from "../../utils/Constants";
// import { hasAnyGroupAdminRole } from "../../utils/Helpers";
import { TableRowPlaceholder } from "../../components/TableRowPlaceholder/TableRowPlaceholder";
import "./styles.css";
// Removed unused imports
import { useNavigate } from "react-router";
export const ManualSalary: React.FC = () => {
  const { t } = useTranslation();
  const { loading } = useAppSelector((state) => state.settings);
  const [data, setData] = useState<ManualSalaryList>(null);
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);
  const [searchText, setSearchText] = useState<string>("");
  // const isAdmin = hasAnyGroupAdminRole([GroupAdmin.CREDIT_ADMIN]);

  // const currentLanguage = i18n.language;
  const [filters, setFilters] = useState<filters>({
    page: 1,
    size: 10,
    searchText: "",
    loadAllDocuments: false,
    status: RelatedPartiesStatus.PENDING
  });
  //    status: isAdmin ? RelatedPartiesStatus.ALL : RelatedPartiesStatus.PENDING
  const navigate = useNavigate();

  useEffect(() => {
    callRequest(setData, filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [timer]);

  const searchInputChanged = (value) => {
    setSearchText(value);
    clearTimeout(timer);
    const newTimer = setTimeout(
      () => setFilters({ ...filters, searchText: value }),
      500
    );
    setTimer(newTimer);
  };

 



  const getStatusColor = (status) => {
    switch (status) {
      case ManualSalarystatus.APPROVED:
        return "btn py-1 rounded-pill mb-0 btn-success";
      case ManualSalarystatus.REJECTED:
        return "btn py-1 rounded-pill mb-0 btn-danger";
      case ManualSalarystatus.PENDING:
        return "btn py-1 rounded-pill mb-0 btn-warning";
      default:
        return "btn py-1 rounded-pill mb-0 btn-secondary";
    }
  };

  
  const handleClick = (item: ManualSalaryObject) => {
    // setDetails(!showDetails);
    navigate("/manual-salary/details", { state: item });
  };

  // Note: tabList is defined but not used in the main list view
  // It's only used in the details page
  // const tabList: TabItem[] = [
  //   { id: "basic", label: "Basic Details" },
  //   { id: "eligibilityResult", label: "Eligibility Result" },
  //   { id: "amlock", label: "Amlock" },
  //   { id: "offers", label: "Offers" },
  //   { id: "eligibilityData", label: "Eligibility Data" },
  // ];
  // const getStatusDisableStatus = () => {
  //   return isAdmin
  //     ? filters.searchText !== "" && !(data?.details?.length > 0)
  //     : true;
  // };

  const changeStatus = (data) => {
    setFilters({ ...filters, status: data, page: 1 });
  };
  return (
    <>
      <div className="box_container">
        <div className="row g-3">
            <div className="col-md-12">
            <div className="row table-header justify-content-end">
              <div className="dropdown margin-end col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                <button
                  className="btn bg-gradient-dark mb-0 dropdown-toggle w-100"
                  data-bs-toggle="dropdown"
                  title="Payoutstatus"
                  // disabled={getStatusDisableStatus()}
                >
                  {t("inputs.related_parties.status")}  (
                  {t("inputs.related_parties.statusData." + filters.status)})
                </button>
                <ul className="dropdown-menu dropdown-right-align">
                  <li key={RelatedPartiesStatus.ALL}>
                    <a
                      className="dropdown-item"
                      onClick={() => changeStatus(RelatedPartiesStatus.ALL)}
                    >
                      {t("inputs.related_parties.statusData.ALL")}
                    </a>
                  </li>
                  <li key={RelatedPartiesStatus.PENDING}>
                    <a
                      className="dropdown-item"
                      onClick={() => changeStatus(RelatedPartiesStatus.PENDING)}
                    >
                      {t("inputs.related_parties.statusData.PENDING")}
                    </a>
                  </li>

                  <li key={RelatedPartiesStatus.APPROVED}>
                    <a
                      className="dropdown-item"
                      onClick={() =>
                        changeStatus(RelatedPartiesStatus.APPROVED)
                      }
                    >
                      {t("inputs.related_parties.statusData.APPROVED")}
                    </a>
                  </li>
                  <li key={RelatedPartiesStatus.REJECTED}>
                    <a
                      className="dropdown-item"
                      onClick={() =>
                        changeStatus(RelatedPartiesStatus.REJECTED)
                      }
                    >
                      {t("inputs.related_parties.statusData.REJECTED")}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
              <div className="row table-header">
                <div className="col-sm-12 col-md-11 mb-2">
                  <div className="input-group search-input align-items-center">
                    <span className="input-group-text">
                      <img alt="" src={Search} />
                    </span>
                    <input
                      className="form-select"
                      value={searchText}
                      placeholder={t("manualSalary.search_input_placeholder")}
                      onChange={(e) => searchInputChanged(e.target.value)}
                    />
                    {filters.searchText && (
                      <button
                        type="button"
                        className="btn-close ps mx-3"
                        aria-label="Close"
                        onClick={() => searchInputChanged("")}
                      ></button>
                    )}
                  </div>
                </div>

                <div className="col-sm-12 col-md-1 mb-2">
                  <div
                    className="d-flex align-items-center justify-content-end"
                    role="toolbar"
                    aria-label="Toolbar with button groups"
                  >
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="First group"
                    ></div>

                    <div
                      className="btn-group"
                      role="group"
                      aria-label="First group"
                    >
                      <button
                        className="btn bg-gradient-dark d-flex-center"
                        onClick={() => exportData(filters, t)}
                        type="button"
                        title="Download"
                        disabled={!(data && data?.details?.length > 0)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="19"
                          fill="currentColor"
                          className="bi bi-download"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12 ">
              <div className="table-responsive" style={{ minHeight: "25rem" }}>
                <table className="table table-hover my-table">
                  {!loading && (
                    <thead>
                      <tr>
                        <th className="px-2 normal-case" scope="col">
                          {t("manualSalary.applicationDate")}
                        </th>
                        <th className="px-2 normal-case" scope="col">
                          {t("manualSalary.idNumber")}
                        </th>
                        <th className="px-2 normal-case" scope="col">
                          {t("manualSalary.nationality")}
                        </th>
                        <th className="px-2 normal-case" scope="col">
                          {t("manualSalary.source")}
                        </th>
                        <th className="px-2 normal-case" scope="col">
                          {t("manualSalary.customerName")}
                        </th>
                        <th className="px-2 normal-case" scope="col">
                          {t("manualSalary.applicationId")}
                        </th>
                        <th className="px-2 text-center normal-case" scope="col">
                          {t("manualSalary.applicationStatus")}
                        </th>
                        <th className="px-2 text-center normal-case" scope="col">
                          {t("manualSalary.offer")}
                        </th>
                        <th className="px-2 text-center normal-case" scope="col">
                          {"Salary"}
                        </th>
                      </tr>
                    </thead>
                  )}
                  <tbody>
                    {loading && <TableRowPlaceholder />}
                    {data?.details?.map((item, key) => (
                      <tr key={key} onClick={()=>handleClick(item)}>
                        <td
                          style={{ maxWidth: 80 }}
                          className="px-2"
                          // scope="col"
                        >
                          {formateDate(item.applicationDate)}
                        </td>
                        <td className="px-2">
                          {item?.nationalId}
                        </td>
                        <td className="px-2">
                          {item?.nationality}
                        </td>
                        <td className="px-2">
                          {item?.source}
                        </td>
                        <td className="px-2">
                          {item?.customerName}
                        </td>
                        <td className="px-2">
                          {item?.financialDataId}
                        </td>
                        <td className="px-2">
                          <div
                            style={{ minWidth: 180, fontSize: "small", whiteSpace: "nowrap" }}
                            className={`${getStatusColor(item?.salaryStage)}`}
                          >
                            {item?.salaryStage}
                          </div>
                        </td>
                        <td className="px-2">
                          {item?.promotionalOffer ? item?.promotionalOffer : "-----"}
                        </td>
                        <td className="px-2">
                          {item?.salaryType ?? 'MANUAL'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {!loading && data?.details?.length === 0 && (
                  <div className="text-center text-muted my-5 py-5">
                    No data Found
                  </div>
                )}
              </div>
              {data && data?.details?.length > 0 && (
                <div className="col-md-12 ">
                  <div className="table-footer">
                    <div className="results-count">
                      <p></p>
                    </div>
                    <div className="results-pagination">
                      <nav>
                        <ul className="pagination">
                          <li key={"9991"} className="page-item">
                            <button
                              className="prev page-link"
                              disabled={filters.page <= 1}
                              onClick={() =>
                                setFilters((res) => ({
                                  ...res,
                                  page: filters.page - 1,
                                }))
                              }
                            >
                              <img alt="" src={Arrow} />
                            </button>
                          </li>

                          {paginationElemnts(
                            data?.details,
                            filters.page,
                            data?.totalCount,
                            setFilters
                          )}
                          <li key={"9992"} className="page-item">
                            <button
                              className="next page-link"
                              disabled={
                                data?.details?.length < 10 ||
                                filters.page == Math.ceil(data?.totalCount / 10)
                              }
                              onClick={() =>
                                setFilters((res) => ({
                                  ...res,
                                  page: filters.page + 1,
                                }))
                              }
                            >
                              <img alt="" src={Arrow} />
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
      </div>
    </>
  );
};
